import { Fragment, useEffect, useState } from 'react';
import classes from './login-textbox.module.css';
import { StringUtils } from '../../../utils/helper_functions';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Install react-icons if not already done
import useInput from './hooks/input-hook'; // Import the custom hook

const LoginTextBox: React.FC<{ type: string; id: string; placeholder: string;validateFunction: (enteredValue: string) => {isValid:boolean,errorMessage:string};onValidationChange: (isValid: boolean, reset: () => void) => void;  }> = (props) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const {value: enteredValue ,isValid,errorMessage, hasError,valueChangeHandler,inputBlurHandler,reset} = useInput({ initialValue: '', validateValue: props.validateFunction });

 useEffect(() => {
  props.onValidationChange(isValid, reset);
}, [isValid, reset, props]);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prevState) => !prevState);
  };

  const isPasswordField = props.type === 'password';

  
  return (
    <Fragment>
      <div className={classes['label-wrapper']}>
        <label className={classes.label} htmlFor={props.id}>{StringUtils.capitalizeFirstLetter(props.id)}</label>
      </div>
      <div className={`${classes['textbox-wrapper']} ${hasError ? classes['textbox-wrapper-error'] : ''}`} >
        <input
          type={isPasswordField && isPasswordVisible ? 'text' : props.type}
          id={props.id}
          name={props.id}
          className={classes.textbox}
          placeholder={props.placeholder}
          value={enteredValue}
          onChange={valueChangeHandler}
          onBlur={inputBlurHandler}
        />
        {isPasswordField && (
          <span
            className={classes['icon-wrapper']}
            onClick={togglePasswordVisibility}
            role="button"
            aria-label={isPasswordVisible ? 'Hide password' : 'Show password'}
          >
            {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
          </span>
        )}
      </div>
      {hasError && <p className={classes["error-text"]}>{errorMessage}</p>}
    </Fragment>
  );
};

export default LoginTextBox;
